var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.97,
    height: 24.98,
    viewBox: "0 0 36.97 24.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 35.97,
    height: 23.98,
    rx: 2,
    fill: "#0873b9",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,72.6q17.984-.005,35.97,0V83.729q-17.984.005-35.97,0V72.6m6.607.873c-.016,3.075.01,6.151,0,9.227a5.021,5.021,0,0,0,.679.058c1.888,0,3.777,0,5.664,0,.262,0,.521-.037.781-.059.006-1.1,0-2.2.005-3.3a13.669,13.669,0,0,0,.057-1.662c.447.37.818.815,1.23,1.219,1,1.01,1.986,2.041,3,3.046a4.061,4.061,0,0,0,.632.6,3.589,3.589,0,0,0,.413.014c3.271-.014,6.542.015,9.813-.014a1.886,1.886,0,0,0-.322-.356c-.96-.788-1.894-1.607-2.845-2.4-.807-.643-1.576-1.328-2.366-1.99-.073-.093-.253-.187-.168-.321.356-.273.743-.509,1.088-.8.847-.7,1.776-1.3,2.628-1.992a17.06,17.06,0,0,0,1.532-1.179c-3.03-.035-6.061,0-9.091-.016a1.93,1.93,0,0,0-.472.034c-1.349.99-2.641,2.053-3.983,3.053a7.088,7.088,0,0,1-1.036.75c-.054-1.3,0-2.611-.028-3.915C11.41,73.475,9.008,73.466,6.607,73.47Z",
    transform: "translate(0.03 -66.217)",
    fill: "#0873b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M199.67,228.813a1.751,1.751,0,0,1,1.651-.651,1.258,1.258,0,0,1,1.183.695C201.56,228.866,200.612,228.885,199.67,228.813Z",
    transform: "translate(-181.684 -208.113)",
    fill: "#0873b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M34.426,10.272c.446,0,.893-.008,1.339.005-.228.659-.562,1.275-.817,1.924,2.7.033,5.395,0,8.091.017a6.286,6.286,0,0,0,.692-.03,6.946,6.946,0,0,1,.015-.948c.338,0,.676,0,1.015,0,.024.3.028.605.024.908.147,0,.3-.01.445-.018.023-.29.037-.579.058-.869a7.116,7.116,0,0,1,.918,0c.005.784.011,1.568,0,2.351-3.543.027-7.086,0-10.629.012-.329,0-.657,0-.986-.012-.377-.457-.75-.916-1.131-1.369C33.76,11.574,34.094,10.923,34.426,10.272Z",
    transform: "translate(-30.421 -9.248)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M238.049,9.457c1.3,0,2.606-.02,3.909.011.064.145.13.29.193.435-.9.037-1.8.071-2.7.076-.008.155-.016.312-.023.468,1.07.035,2.143-.039,3.211.045a5.624,5.624,0,0,1,.565,1.013c-.217.282-.467.539-.709.8-.1.146-.288.117-.441.124-1.5,0-3,0-4.5,0-.382.016-.665-.279-.993-.423-.033.6-.01,1.205-.017,1.807-2.08.016-4.162.024-6.242,0,0-1.131-.005-2.263,0-3.394,1.482,0,2.965.005,4.447,0,.008.4.006.805,0,1.209-.977.021-1.956,0-2.934.011a6.891,6.891,0,0,0-.012,1.218c1.147.032,2.295.016,3.441.007.019-.813,0-1.627.005-2.44.7,0,1.4,0,2.093,0,.322.331.581.713.892,1.053.084.131.256.088.389.1,1.051-.005,2.1,0,3.155,0-.066-.182-.138-.36-.215-.538-.92,0-1.84,0-2.76,0-.316.045-.438-.3-.6-.495C237.936,10.236,238.052,9.82,238.049,9.457Z",
    transform: "translate(-209.557 -8.502)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M65.253,10.558a4.831,4.831,0,0,1,.969-.018c0,.148-.006.3-.013.445-.323.006-.646.006-.968,0C65.241,10.841,65.245,10.7,65.253,10.558Z",
    transform: "translate(-59.343 -9.481)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M83.175,10.543a5.157,5.157,0,0,1,.953-.005c0,.148,0,.3,0,.444-.318,0-.638,0-.956,0C83.167,10.834,83.17,10.689,83.175,10.543Z",
    transform: "translate(-75.659 -9.476)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M164.129,10.549a4.909,4.909,0,0,1,.95,0c0,.145,0,.29,0,.434-.318.009-.637.009-.956,0C164.121,10.842,164.124,10.7,164.129,10.549Z",
    transform: "translate(-149.331 -9.484)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M192.13,26.432c.638-.031,1.276-.011,1.914-.011.054.49.038.984.046,1.476-.651.007-1.3.017-1.953-.006C192.134,27.4,192.136,26.918,192.13,26.432Z",
    transform: "translate(-174.822 -23.976)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M308.038,54.591c.3,0,.61,0,.915.016,0,.146,0,.291,0,.437-.324.012-.648.015-.97,0C308,54.892,308.019,54.742,308.038,54.591Z",
    transform: "translate(-280.255 -49.794)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M324.757,54.591a9.162,9.162,0,0,1,.958,0c0,.151,0,.3,0,.453-.317,0-.634,0-.95-.007C324.757,54.887,324.756,54.739,324.757,54.591Z",
    transform: "translate(-295.522 -49.784)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M0,69.6q17.984.005,35.97,0v.264q-17.984-.009-35.97,0Z",
    transform: "translate(0.03 -63.485)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M0,199.36q17.984.009,35.97,0v.266q-17.984-.005-35.97,0Z",
    transform: "translate(0.03 -181.849)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M327.57,211.375c.635,0,1.27,0,1.906,0a7.881,7.881,0,0,0,.015.824c.407-.007.815,0,1.222,0,.005.2,0,.4-.014.6-.42,0-.839,0-1.257.008,0,.669-.005,1.339,0,2.008a12.023,12.023,0,0,1,1.206.023q-.005.354,0,.711c-.557.042-1.116.01-1.673.022a1.817,1.817,0,0,1-1.121-.24.733.733,0,0,1-.282-.576c-.034-.627.03-1.259-.038-1.885-.311.008-.622.011-.932,0q0-.336.005-.67c.313-.008.627-.005.941-.009C327.563,211.921,327.563,211.648,327.57,211.375Z",
    transform: "translate(-297.203 -192.807)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M35.528,220.207a4.483,4.483,0,0,1,3.718-.3c.469.194.985.549,1.009,1.094.022.67,0,1.341.012,2.012-.624.04-1.25.018-1.875.012-.016-.592.011-1.185-.009-1.776a.729.729,0,0,0-.4-.643,2.361,2.361,0,0,0-1.6-.105c-.335.094-.738.282-.793.656-.028.632,0,1.266-.01,1.9-.619.006-1.236,0-1.855,0-.04-1.065-.016-2.134-.013-3.2.592,0,1.183-.009,1.774,0C35.5,219.976,35.515,220.091,35.528,220.207Z",
    transform: "translate(-30.646 -200.344)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M177.462,220.551a4.138,4.138,0,0,1,2.376-.837,6.24,6.24,0,0,1,3.02.4,1.723,1.723,0,0,1,1.074,1.563c-1.626.042-3.255-.031-4.879.036a.853.853,0,0,0,.4.582,2.624,2.624,0,0,0,1.379.2c.452,0,.8-.384,1.259-.347.58.008,1.161-.012,1.741.02a3.241,3.241,0,0,1-2.064,1,8.355,8.355,0,0,1-2.878-.068,2.44,2.44,0,0,1-1.629-.95,1.253,1.253,0,0,1,.2-1.6m1.631.539c.942.071,1.89.053,2.834.044a1.258,1.258,0,0,0-1.183-.695A1.751,1.751,0,0,0,179.094,221.091Z",
    transform: "translate(-161.108 -200.39)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M73.415,82.534c2.4,0,4.8.005,7.2,0,.03,1.3-.026,2.611.028,3.915a7.09,7.09,0,0,0,1.036-.75c1.342-1,2.634-2.063,3.983-3.053a1.928,1.928,0,0,1,.472-.034c3.03.013,6.062-.019,9.091.016A17.067,17.067,0,0,1,93.7,83.8c-.852.694-1.781,1.291-2.628,1.992-.345.289-.732.525-1.088.8-.085.134.1.228.168.321.79.661,1.559,1.347,2.366,1.99.951.8,1.885,1.616,2.845,2.4a1.886,1.886,0,0,1,.322.356c-3.271.029-6.542,0-9.813.014a3.586,3.586,0,0,1-.413-.014,4.063,4.063,0,0,1-.632-.6c-1.009-1-1.991-2.036-3-3.046-.412-.4-.783-.849-1.23-1.219a13.666,13.666,0,0,1-.057,1.662c-.01,1.1,0,2.2-.005,3.3-.26.022-.519.058-.781.059-1.887,0-3.776,0-5.664,0a5.017,5.017,0,0,1-.679-.058C73.425,88.685,73.4,85.609,73.415,82.534Z",
    transform: "translate(-66.778 -75.281)",
    fill: "#fae80c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnet);
export default __webpack_public_path__ + "static/media/knet.730ccf94f194597c8f9639a115e3d37a.svg";
export { ForwardRef as ReactComponent };